import { render, staticRenderFns } from "./SDKConfigurationsBulkUpdate.vue?vue&type=template&id=394872ee"
import script from "./SDKConfigurationsBulkUpdate.vue?vue&type=script&lang=js"
export * from "./SDKConfigurationsBulkUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports